export const editCourseTabs = [
  { id: "details", label: "Details" },
  { id: "content", label: "Content and versions" },
  { id: "sessions", label: "Sessions" },
  { id: "availability", label: "Availability" },
] as const;

export type EditCourseTabId = (typeof editCourseTabs)[number]["id"];

/** The edit course page opens on Content and versions when the URL names no tab. */
export const defaultEditCourseTab: EditCourseTabId = "content";

/**
 * The tabs a course has. An instructor-led course has no content or versions to manage, so it has
 * no Content and versions tab; it has a Sessions tab instead, which an online course doesn't.
 */
export const getEditCourseTabs = (isInstructorLed: boolean) =>
  editCourseTabs.filter((tab) => tab.id !== (isInstructorLed ? "content" : "sessions"));

/** The tab to show: the one in the URL when the course has it, otherwise the course's first. */
export const resolveEditCourseTab = (
  tab: EditCourseTabId | undefined,
  isInstructorLed: boolean,
): EditCourseTabId => {
  const tabs = getEditCourseTabs(isInstructorLed);
  const requested = tab ?? defaultEditCourseTab;
  return tabs.some((candidate) => candidate.id === requested) ? requested : tabs[0].id;
};

export const isEditCourseTabId = (value: unknown): value is EditCourseTabId =>
  editCourseTabs.some((tab) => tab.id === value);

export type EditCourseSearchParams = {
  tab?: EditCourseTabId;
};

export const validateEditCourseSearch = (
  search: Record<string, unknown>,
): EditCourseSearchParams => ({
  tab: isEditCourseTabId(search.tab) ? search.tab : undefined,
});
